import { USER_KEY } from '../constants/constants';
import { loadState } from './localStore';
export default () => loadState(USER_KEY) || null;
//# sourceMappingURL=getUser.js.map